"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subAppHybLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
// providers
const providers_1 = require("./providers");
const renderUtils_1 = require("../utils/renderUtils");
const initializer_1 = require("./initializer");
const subAppHybLoader = async ({ API, app: App, libraries = [], trackerConfig, featureFlagConfig, translationsConfig, }) => {
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(providers_1.SubAppHybProviders, { children: (0, jsx_runtime_1.jsx)(App, {}) }));
    await (0, initializer_1.subAppHybInitializer)({ API, libraries, trackerConfig, featureFlagConfig, translationsConfig });
    ReactDOM.render((0, jsx_runtime_1.jsx)(AppWithProviders, {}), (0, renderUtils_1.getRootElement)());
};
exports.subAppHybLoader = subAppHybLoader;
//# sourceMappingURL=index.js.map